import { lazyRouteComponent } from "@tanstack/react-router";
import { LayoutGrid } from "lucide-react";

import type { PageDef } from "@/app/registry";

export const MOVERS = ["price_gainers", "price_losers", "oi_gainers", "oi_losers"] as const;
export type Mover = (typeof MOVERS)[number];
export const BUILDUPS = ["all", "long_buildup", "short_buildup", "short_covering", "long_unwinding"] as const;
export type BuildupFilter = (typeof BUILDUPS)[number];

export interface StocksFnoSearch {
  /** Sector picked on the heat map (default: the largest by turnover). */
  sector?: string;
  /** Heat map colour: price change or OI change. */
  color: "price" | "oi";
  mover: Mover;
  bu: BuildupFilter;
}

export function parseStocksFnoSearch(s: Record<string, unknown>): StocksFnoSearch {
  return {
    ...(typeof s.sector === "string" && s.sector.length <= 60 ? { sector: s.sector } : {}),
    color: s.color === "oi" ? "oi" : "price",
    mover: MOVERS.includes(s.mover as Mover) ? (s.mover as Mover) : "price_gainers",
    bu: BUILDUPS.includes(s.bu as BuildupFilter) ? (s.bu as BuildupFilter) : "all",
  };
}

export const pages: PageDef[] = [
  {
    path: "/app/stocks-fno",
    proOnly: true,
    title: "Stocks F&O",
    component: lazyRouteComponent(() => import("./StocksFnoPage"), "StocksFnoPage"),
    nav: { label: "Stocks F&O", icon: LayoutGrid, group: "Markets", order: 12 },
    validateSearch: parseStocksFnoSearch,
  },
];
